import { BaseFilterButton } from 'components/base-table/filters';
import { Button, FormControl, FormLabel, HStack, Input, Stack, useBoolean, useDisclosure } from 'design-system';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

type TInputs = {
  deliveryDate: string;
};

const defaultValues: TInputs = {
  deliveryDate: '',
};

export const OrderDeliveryDateFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  // Update active filter button
  useEffect(() => {
    if (params.deliveryDate) setIsActive.on();
    else setIsActive.off();
  }, [params.deliveryDate]);

  const { control, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  // Update values
  const updateValues = () => {
    setValue('deliveryDate', (params?.deliveryDate as string) ?? '');
  };

  useEffect(() => {
    updateValues();
  }, [params.deliveryDate]);

  const onSubmit = (data: TInputs) => {
    params.deliveryDate = data.deliveryDate;

    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  const handleDisableFilterButton = () => {
    const isDisabled = Object.keys(formState.dirtyFields).length ? false : true;
    return isDisabled;
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name='deliveryDate'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Delivery Date</FormLabel>
                <Input type='date' onChange={onChange} size='sm' onBlur={onBlur} value={value} name={name} />
              </FormControl>
            )}
          />

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
